import { useNotificationStore } from '@/store/notifications/notificationStore';
import { Notification } from '@/models';
import { App } from 'vue';

export const errorHandler = (app: App<Element>) => {
  window.addEventListener('unhandledrejection', (event) => {
    console.error(event.reason);
  });

  window.addEventListener('error', (event) => {
    console.error(event.error);
  });

  app.config.errorHandler = (err) => {
    const notificationStore = useNotificationStore();
    notificationStore.addNotification(
      new Notification()
        .setTitle('Fehler')
        .setText('Etwas ist schief gelaufen.')
        .setType('error')
    );
    console.error(err);
  };
};
